import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=38ecc4d3&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=38ecc4d3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecc4d3",
  null
  
)

export default component.exports